import { countrySchema } from "@redotech/redo-model/geographic-unit";
import { z } from "zod";

export const getCountries = { input: z.null(), output: z.array(countrySchema) };
